import {
  AtsCandidateSourcesDocument,
  CreateCandidateSourceDocument,
  CreateCandidateSourceMutation,
  CreateCandidateSourceMutationVariables,
  GetCandidateSourcesDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export type CreateCandidateSourcePayload =
  CreateCandidateSourceMutation['atsMutations']['createAtsCandidateSource']

export const useCreateCandidateSources = () => {
  const [CreateCandidateSource, { loading }] = useMutation(CreateCandidateSourceDocument, {
    extractorFn: (data: CreateCandidateSourceMutation) =>
      data.atsMutations.createAtsCandidateSource,
  })

  return {
    loading,
    create(variables: CreateCandidateSourceMutationVariables) {
      return CreateCandidateSource({
        variables,
        refetchQueries: [GetCandidateSourcesDocument, AtsCandidateSourcesDocument],
      })
    },
  }
}
